import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const defaultMeta = { meta_key: '', meta_value: '' };

export default function PlanMetaModal({ show, onHide, onSave, meta, isEditing }) {
  const [form, setForm] = useState(defaultMeta);
  const [error, setError] = useState('');

  useEffect(() => {
    setForm(meta ? { ...meta } : defaultMeta);
    setError('');
  }, [meta, show]);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (!form.meta_key) {
      setError('Meta key is required.');
      return;
    }
    onSave(form);
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>{isEditing ? 'Edit Plan Meta' : 'Add Plan Meta'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <div className="alert alert-danger">{error}</div>}
          <Form.Group className="mb-2">
            <Form.Label>Meta Key</Form.Label>
            <Form.Control name="meta_key" value={form.meta_key} onChange={handleChange} required />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Meta Value</Form.Label>
            <Form.Control name="meta_value" value={form.meta_value} onChange={handleChange} />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>Cancel</Button>
          <Button type="submit" variant="primary">{isEditing ? 'Update' : 'Add'}</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
